// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"372":"d5cd9eab","494":"52e19f43","510":"8b1c7591","939":"4239f740"}[chunkId] + ".chunk.css";
};